import { render, staticRenderFns } from "./SyncButtons.vue?vue&type=template&id=48324d87&scoped=true"
import script from "./SyncButtons.vue?vue&type=script&lang=js"
export * from "./SyncButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48324d87",
  null
  
)

export default component.exports